import React from 'react';
import { lazy, Suspense, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import MonoChart from './components/MonoChart/monoChart';
import Spinner from './components/Spinner/Spinner';
//import { TopologyGraphMemo } from './components/Topology';
//import { appTopologyUrlName } from './components/Topology/Topology';

import './index.css'
import { Instrument } from './components/CommonClasses/Instrument';
// Lazy load the components
const ExplorerScatter = lazy(() => import('./ExplorerScatter'));
//const MonoChart = lazy(() => import('./components/MonoChart/monoChart'));
//MonoChart

const baseUrl = process.env.PUBLIC_URL || '';

const explorerAlternativesNames= ['explorer', 'scanner', 'screener','screener-explorer'];
//const topologyAlternativesNames= ['correlation', 'topology'];

const isPathMatching = (path: string,  validPaths:string[]): boolean => {
  return validPaths.some((segment) => path.startsWith(`${baseUrl}/${segment}`));
};

const getSymbolOrPITSymbolFromPath = (): {sym: string | undefined, appname: string } => {
  const currentPath = window.location.pathname;
  const pathWithoutBaseUrl = currentPath.startsWith(baseUrl)
  ? currentPath.slice(baseUrl.length)
  : currentPath;
  const pathParts = pathWithoutBaseUrl.replace(/^\/|\/$/g, '').split('/');
  if (pathParts.length==0){
      return {sym: undefined, appname: ''}
  }

  if (pathParts.length==1){
    if ( pathParts.some(part => explorerAlternativesNames.includes(part))  )
    {
      return {sym: undefined, appname: pathParts[0]}
    } else {
      return {sym: pathParts[0], appname: '' }
    }
  }

  if ( pathParts.some(part => explorerAlternativesNames.includes(part))  )
    {
      return {sym: pathParts[1], appname: pathParts[0]}
    } else {
      return {sym: pathParts[0], appname: '' }
    }

};

const setInstrument = (newInstrument: Instrument | undefined) => {
  const sym = getSymbolOrPITSymbolFromPath();
  if (sym.sym && newInstrument){
    const newPath = `${baseUrl}/${sym.appname || ''}/${newInstrument.Symbol}`.replace(/\/+/g, '/');
    window.history.replaceState({}, '', newPath);
  }


};


function App() {
  const [route, setRoute] = useState(window.location.pathname);
  console.log('window.location.pathname=',window.location.pathname)
  

  useEffect(() => {
    const handleLocationChange = () => {
      setRoute(window.location.pathname);
    }

    // Listen for popstate event in case of browser navigation
    window.addEventListener('popstate', handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);



  const determineComponentToRender2 = () => {
    const path = window.location.pathname;
    const SymbolOrPITSymbol = getSymbolOrPITSymbolFromPath();
  
    if (isPathMatching(path,explorerAlternativesNames)) {
      return <ExplorerScatter SymbolOrPITSymbol={SymbolOrPITSymbol.sym } setInstrument={setInstrument} />;
  }
/*
  if (isPathMatching(path,topologyAlternativesNames)) {
      return <TopologyGraphMemo SymbolOrPITSymbol={SymbolOrPITSymbol.sym || 'MSFT'} setInstrument={setInstrument} />;
  }
*/
  return <ExplorerScatter SymbolOrPITSymbol={SymbolOrPITSymbol.sym } setInstrument={setInstrument} />;
  }
  return (
    <Suspense fallback={<Spinner />}>
      {determineComponentToRender2()}
    </Suspense>
  );
}

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  
    <App />
  
);